import React from "react";
import Form from '~/common/components/Form';
import Textarea from '~/common/components/textarea';
// Components
import ImgUploadForm from "../components/ImgUploadForm";
import ProfileEditForm from "../components/ProfileEditForm";

const ProfileInfoEdit = ({ useForm, emailReceiveCheck, emailReceiveTerm }) => {
	return (
		<div className="profile-info-edit-wrap">
			<div className="form-wrap">
				<ImgUploadForm useForm={useForm} />
				<Form useForm={useForm}>
					<Textarea 
						// label="자기소개"
						name="UserProfile.introduction"
					/>
				</Form>
			</div>
			{/* ProfileEditForm  useForm  emailReceiveCheck*/}

			<ProfileEditForm
				useForm={useForm}
				emailReceiveCheck={emailReceiveCheck}
				emailReceiveTerm={emailReceiveTerm}
			/>
		</div>
	);
};

export default ProfileInfoEdit;
